import { useForm } from '@mantine/form';

import { Funnel } from '../types';

export type Fields = Pick<Funnel, 'name' | 'color'>;
type Props = {
  initialValues?: Fields;
};

export const useFunnelForm = ({ initialValues }: Props) => {
  return useForm<Fields>({
    initialValues: {
      name: initialValues?.name || '',
      color: initialValues?.color || '',
    },

    validate: {
      name: (val) => (!val ? 'Name is required' : null),
      color: (val) => (!val ? 'Color is required' : null),
    },
  });
};
